























































import { defineComponent, reactive, toRefs, computed, ref, onMounted, watch } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import ExcelJS from 'exceljs';
import moment from 'moment';
import SheetListTab from "../../components/SheetListTab.vue";
import AlertArea from "../../components/AlertArea.vue";
import { Sheet, Condition } from "../../modules/teacher/VariousResultDownload"


export interface Data {
  tabNo: number
  condition: Condition
  comboboxKinds: any[]
  sheets: Sheet[]
  KindEnum: Readonly<{TwentyMin: number; Various: number; Kimatsu: number}>
  errors: string[]
  isShow: boolean
  fields: any[]
  isAllChecked: boolean
}

export default defineComponent({
  components: {
    "sheet-list-tab": SheetListTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * ref
     ******************************/

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      tabNo: 3,
      condition: new Condition(),
      comboboxKinds: context.root.$store.getters.getComboboxKinds(true).filter((x: any) => x.value != Common.KindEnum.Kimatsu),
      sheets: new Array<Sheet>(),
      KindEnum: Common.KindEnum,
      errors: [],
      isShow: false,
      fields: [
        {key: "sheet_group_key", label: "試験ID", sortable: false, class: 'text-center b-table-th-td'},
        {key: "nendo", label: "年度", sortable: false, class: 'text-center b-table-th-td'},
        {key: "exec_date", label: "実施月", sortable: false, class: 'text-center b-table-th-td'},
        {key: "grade", label: "学年", sortable: false, class: 'text-center b-table-th-td'},
        {key: "name", label: "試験名", sortable: false, class: 'text-center b-table-th-td'},
        {key: "isSelected", label: "選択", sortable: false, class: 'text-center b-table-th-td'},
      ],
      isAllChecked: false
    });

    /******************************
     * 選択列 ヘッダーチェックボックス
     ******************************/

    watch(() => state.isAllChecked, (newVal, oldVal) => {
      state.sheets.forEach(x => x.isSelected = newVal);
    });

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/various_result_download?${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        state.sheets = response.data.sheets.map((x: any) => new Sheet(x));
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * Excel用データ取得
     ************************************************************/

    const download = async (): Promise<void> => {
      
      const targetSheets = state.sheets.filter(x => x.isSelected);

      if(targetSheets.length == 0){
        alert("出力対象が選択されていません。");
        return;
      }

      if(!window.confirm("ダウンロードを開始します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      let output_infos: any[] = [];
      let subjects: any[] = [];
      let curriculums: any[] = [];

      for(const targetSheet of targetSheets) {
        const param = {sheet_group_keys: [targetSheet.sheet_group_key]};
        await http.post(`/api/various_result_download/search_output_data`, param).then(response => {
          response.data.output_infos.forEach((x: any) => {
            output_infos.push(x);
          });
          subjects = response.data.subjects;
          curriculums = response.data.curriculums;
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
          context.root.$store.dispatch("hideOverlay");
          return;
        });
      }

      try{
        const workbook = new ExcelJS.Workbook();
        workbook.addWorksheet('受講情報');
        const worksheet = workbook.getWorksheet('受講情報');

        // 1行目ヘッダ
        let colNo = 4;
        worksheet.getCell(1, colNo).value = "合計";
        worksheet.mergeCells(1, colNo, 1, colNo + 1);
        colNo += 2;
        curriculums.forEach((x: any) => {
          worksheet.getCell(1, colNo).value = x.name;
          worksheet.mergeCells(1, colNo, 1, colNo + 1);
          colNo += 2;
        });
        subjects.forEach((x: any) => {
          worksheet.getCell(1, colNo++).value = x.name;
        });

        for(let i = 4; i < colNo; i++){
          worksheet.getRow(1).getCell(i).border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" }
          };
        }

        // 2行目ヘッダ
        colNo = 1;
        worksheet.getCell(2, colNo++).value = "研究用ID";
        worksheet.getCell(2, colNo++).value = "学年";
        worksheet.getCell(2, colNo++).value = "試験";
        worksheet.getCell(2, colNo++).value = "得点";
        worksheet.getCell(2, colNo++).value = "順位";
        curriculums.forEach((x: any) => {
          worksheet.getCell(2, colNo++).value = "得点";
          worksheet.getCell(2, colNo++).value = "順位";
        });
        subjects.forEach((x: any) => {
          worksheet.getCell(2, colNo++).value = "得点";
        });

        for(let i = 1; i < colNo; i++){
          worksheet.getRow(2).getCell(i).border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" }
          };
        }

        // 3行目以降 成績情報
        let rowNo = 3;
        output_infos.forEach((x: any) => {
          colNo = 1;
          worksheet.getCell(rowNo, colNo++).value = x.research_id;
          worksheet.getCell(rowNo, colNo++).value = context.root.$store.getters.getGradeNameByValue(x.grade);
          worksheet.getCell(rowNo, colNo++).value = x.sheet_name;

          if(x.total_info){
            worksheet.getCell(rowNo, colNo++).value = x.total_info.score == "-" ? "" : x.total_info.score;
            worksheet.getCell(rowNo, colNo++).value = x.total_info.grade_rank == "-" ? "" : x.total_info.grade_rank;
          }else{
            colNo += 2;
          }

          curriculums.forEach((curriculum: any) => {
            const curriculum_info = x.curriculum_infos.filter((x: any) => x.curriculum_id == curriculum.id)
            if(curriculum_info.length > 0){
              worksheet.getCell(rowNo, colNo++).value = curriculum_info[0].score;
              worksheet.getCell(rowNo, colNo++).value = curriculum_info[0].grade_rank;
            }else{
              colNo += 2;
            }
          });
          subjects.forEach((subject: any) => {
            const subject_info = x.subject_infos.filter((x: any) => x.subject_id == subject.id);
            if(subject_info.length > 0){
              worksheet.getCell(rowNo, colNo++).value = subject_info[0].score;
            }else{
              colNo++;
            }
          });

          rowNo++;
        });


        const uint8Array = await workbook.xlsx.writeBuffer()
        const blob = new Blob([uint8Array], { type: 'application/octet-binary' });
        const a = document.createElement('a');
        a.href = (window.URL || window.webkitURL).createObjectURL(blob);
        a.download = `諸テスト結果.xlsx`;
        a.click();
        a.remove();
      }catch(e){
        state.errors = ["予期せぬ例外が発生しました。"];
      }finally{
        context.root.$store.dispatch("hideOverlay");
      }
    }

    /******************************
     * 実施日を画面表示文言にコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('M月') : "-";
    };

    /******************************
     * クリアボタン押下
     ******************************/

    const clearCondition = () => {
      state.condition = new Condition();
    };

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      state.condition = new Condition();
      state.condition.nendo = context.root.$store.getters.getCurrentNendo();
      await search();
      state.isShow = true;
    });

    return {
      ...toRefs(state),
      search,
      searchClick,
      download,
      convertExecDate,
      clearCondition,
    }
  }
});
